import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

const LeadSourcesChart: React.FC = () => {
  const data = {
    labels: ['WhatsApp', 'Instagram', 'Facebook', 'Google', 'Referral'],
    datasets: [
      {
        data: [45, 25, 15, 10, 5],
        backgroundColor: [
          '#25D366', // WhatsApp Green
          '#E4405F', // Instagram Pink
          '#1877F2', // Facebook Blue
          '#4285F4', // Google Blue
          '#9CA3AF', // Gray for referral
        ],
        borderWidth: 2,
        borderColor: '#ffffff',
        hoverBorderWidth: 3,
        cutout: '60%',
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        cornerRadius: 8,
        callbacks: {
          label: function (context: any) {
            const label = context.label || ''
            const value = context.parsed || 0
            return `${label}: ${value}%`
          },
        },
      },
    },
  }

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="h3" fontWeight="bold">
            Lead Sources
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Last 30 days
          </Typography>
        </Box>
        <Box sx={{ height: 300 }}>
          <Doughnut data={data} options={options} />
        </Box>
      </CardContent>
    </Card>
  )
}

export default LeadSourcesChart
